import React from 'react';
import { connect } from 'react-redux';
import VersionMessage from '@bibliocommons/version-message';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import FeedbackContainer from './FeedbackContainer';
import { currentLibrarySelector } from '../selectors/LibrarySelector';


/* eslint-disable react/no-danger */

function mapStateToProps(state) {
  const library = currentLibrarySelector(state);
  return {
    footer: state.getIn(['templates', 'footer']),
    appVersion: state.getIn(['app', 'appVersion']),
    cmsEnabled: library.get('cmsEnabled')
  };
}

export class FooterContainer extends BcReactComponent {
  render() {
    if (this.props.footer) {
      return (
        <div className={this.props.cmsEnabled ? 'cms-footer' : 'container'} >
          <FeedbackContainer />
          {/* eslint-disable react/no-danger */}
          <div className="cp-footer" dangerouslySetInnerHTML={{ __html: this.props.footer }} />
          {/* eslint-enable */}
          <VersionMessage version={this.props.appVersion} />
        </div>
      );
    }

    return null;
  }
}

FooterContainer.propTypes = {
  footer: React.PropTypes.string
};

export default connect(mapStateToProps)(FooterContainer);



// WEBPACK FOOTER //
// ./app/containers/FooterContainer.jsx